"use client";
import React from "react";
import { Home, Search, ArrowLeft } from "lucide-react";
import { motion } from "motion/react";
import { GlassCard } from "@/src/components/GlassCard";
import { Button } from "@/src/components/ui/button";
import Link from "next/link";

export const NotFoundPage: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="max-w-2xl w-full"
      >
        <GlassCard className="p-12 text-center">
          <div className="mb-8">
            <Search className="w-24 h-24 text-walnut-400 dark:text-walnut-600 mx-auto mb-4" />
            <h1 className="text-9xl font-bold text-walnut-300 dark:text-walnut-700 mb-4">
              404
            </h1>
          </div>
          <h2 className="text-4xl font-bold text-walnut-900 dark:text-white mb-4">
            Page Not Found
          </h2>
          <p className="text-lg text-walnut-700 dark:text-walnut-300 mb-8">
            Sorry, the page you&apos;re looking for doesn&apos;t exist or has
            been moved.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              href="/"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-xl bg-gradient-to-r from-walnut-600 to-walnut-700 dark:from-walnut-500 dark:to-walnut-600 text-white font-semibold hover:shadow-lg hover:shadow-walnut-500/30 transition-all duration-300 hover:scale-105"
            >
              <Home className="w-5 h-5" />
              Back to Home
            </Link>
            <Button
              onClick={() => window.history.back()}
              variant="secondary"
              size="lg"
              className="hover:scale-105"
            >
              <ArrowLeft className="w-5 h-5" />
              Go Back
            </Button>
          </div>
        </GlassCard>
      </motion.div>
    </div>
  );
};
